import { SignatureComment } from '../../../../_core/domain/models/signature/signature-comment.model';
import { SignatureCommentRaw } from '../../../../_core/domain/models/signature/signature-comment.raw-model';

export class SignatureCommentNormalizer {
  public static normalize(raw: SignatureCommentRaw): SignatureComment {
    return {
      label: raw.comment,
      value: raw.comment,
      origin: raw.origin,
    };
  }

  public static normalizeList(rawList: SignatureCommentRaw[]): SignatureComment[] {
    return rawList.map(this.normalize);
  }
}
